export const SIGNUP_ERROR_COPY = {
    emailAlreadyExists: "An account with this email already exists. Sign in or reset your password.",
    emailNotConfirmed: "Please confirm your email first. Check your inbox for the link from Abbi’s Way, or resend it.",
    weakPassword: "Your password needs at least 8 characters, with a small letter, a capital letter, a number and a special character.",
    invalidEmail: "Please enter a valid email address.",
    userCreateError: "We couldn't create your account just now. Please try again in a few minutes.",
    network: "We couldn't reach Abbi’s Way. Check your connection and try again.",
    server: "Something went wrong on our side. Please try again later.",
    unknown: "Something went wrong. Please try again.",
};
function errorCodes(error) {
    const errors = error?.data?.errors;
    if (!errors || typeof errors !== "object") {
        return [];
    }
    return Object.values(errors).filter((v) => typeof v === "string");
}
export function isEmailNotConfirmedError(error) {
    return errorCodes(error).includes("emailNotConfirmed");
}
export function mapAuthError(error) {
    const codes = errorCodes(error);
    const has = (c) => codes.some((code) => code === c);
    if (has("emailAlreadyExists")) {
        return {
            kind: "emailAlreadyExists",
            message: SIGNUP_ERROR_COPY.emailAlreadyExists,
            actions: ["signIn", "resetPassword"],
        };
    }
    if (has("emailNotConfirmed")) {
        return {
            kind: "emailNotConfirmed",
            message: SIGNUP_ERROR_COPY.emailNotConfirmed,
            actions: ["resendConfirmation"],
        };
    }
    if (has("weakPassword") || error?.data?.errors?.password) {
        return { kind: "weakPassword", message: SIGNUP_ERROR_COPY.weakPassword };
    }
    if (error?.data?.errors?.email) {
        return { kind: "invalidEmail", message: SIGNUP_ERROR_COPY.invalidEmail };
    }
    if (has("userCreateError") || has("userEventCreationError")) {
        return {
            kind: "userCreateError",
            message: SIGNUP_ERROR_COPY.userCreateError,
        };
    }
    const status = error?.status;
    if (status === "FETCH_ERROR" ||
        status === "TIMEOUT_ERROR" ||
        (error instanceof Error && /network/i.test(error.message))) {
        return { kind: "network", message: SIGNUP_ERROR_COPY.network };
    }
    if (typeof status === "number" && status >= 500) {
        return { kind: "server", message: SIGNUP_ERROR_COPY.server };
    }
    return { kind: "unknown", message: SIGNUP_ERROR_COPY.unknown };
}
